import { observer } from 'mobx-react-lite'
import type { FunctionComponent } from 'react'
import { useMemo } from 'react'

import { LinkButton } from '@components/button/link'
import { useStores } from '@lib/store/useStores'
import { TEXT } from '@lib/utils/text'

export const GetStepButton: FunctionComponent<Props> = observer(
    ({ size = 'medium' }) => {
        const {
            linkingStore: { appDownloadLink },
        } = useStores()

        const link = useMemo(() => {
            return (
                appDownloadLink ?? process.env.NEXT_PUBLIC_ORGANIC_DOWNLOAD_URL
            )
        }, [appDownloadLink])

        return (
            <LinkButton
                preset='primary'
                size={size}
                placement='section'
                title={TEXT.getStep}
                data-testid='getApp.button'
                href={link}
            >
                {TEXT.getStep}
            </LinkButton>
        )
    },
)

interface Props {
    size?: 'small' | 'medium'
}
